import { render, staticRenderFns } from "./Examin.vue?vue&type=template&id=1a5a8ec8&scoped=true"
import script from "./Examin.vue?vue&type=script&lang=js"
export * from "./Examin.vue?vue&type=script&lang=js"
import style0 from "./Examin.vue?vue&type=style&index=0&id=1a5a8ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a8ec8",
  null
  
)

export default component.exports